export default __webpack_public_path__ + "a3dd9307036f2d46a5361abfba7d71ef.png";